export const PROMOTION_DATA = {
    LOAD: 'PROMOTION_DATA_LOAD',
    SUCCESS: 'PROMOTION_DATA_SUCCESS',
    FAIL: 'PROMOTION_DATA_FAIL',

    LOAD_SUBTENANT: 'SUBTENANT_PROMOTION_DATA_LOAD',
    SUCCESS_SUBTENANT: 'SUBTENANT_PROMOTION_DATA_SUCCESS',
    FAIL_SUBTENANT: 'SUBTENANT_PROMOTION_DATA_FAIL',
}